import React from 'react';
import { Card } from './ui/card';

export const VideoSection = () => {
  return (
    <section id="video" className="py-20 lg:py-32">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            See It In Action
          </h2>
          <p className="text-lg text-muted-foreground">
            Watch how APIfromSQL transforms your SQL scripts into production-ready APIs
          </p>
        </div>

        {/* Video Container */}
        <div className="max-w-5xl mx-auto">
          <Card className="border-2 shadow-2xl overflow-hidden bg-card">
            <div className="aspect-video">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/9548_E09OaA?autoplay=1&mute=1&loop=1&playlist=9548_E09OaA&controls=1&modestbranding=1"
                title="APIfromSQL  Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </Card>
          
          {/* Video Description */}
          <div className="mt-8 text-center">
            <p className="text-muted-foreground">
              This demo video shows the complete process from uploading a SQL script to downloading your generated .NET API project.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
